/* PDP related products — slider behaviour. */
(function () {
  'use strict';

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function maybeFetchRecommendations(root) {
    if (root.dataset.pdpRpRecsFetched === 'true') return false;
    if (!('pdpRpNeedsRecs' in root.dataset)) return false;

    var productId = root.dataset.productId;
    var sectionId = root.dataset.sectionId;
    var max = parseInt(root.dataset.maxProducts || '8', 10);
    if (!productId || !sectionId) return false;

    root.dataset.pdpRpRecsFetched = 'true';

    var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + max +
      '&intent=related';

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('rec fetch failed');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-pdp-rp]');
        if (!fresh) return;
        // Replace the inner content (preserve outer root + dataset).
        var oldInner = root.querySelector('.pdp-rp__inner');
        var newInner = fresh.querySelector('.pdp-rp__inner');
        if (oldInner && newInner) {
          oldInner.replaceWith(newInner);
        }
        // Re-init slider behaviour on the refreshed section.
        delete root.dataset.pdpRpInit;
        setupSection(root);
      })
      .catch(function () {
        // Silently fall back to whatever manual content is rendered.
      });

    return true;
  }

  function setupSection(root) {
    if (root.dataset.pdpRpInit === 'true') return;
    root.dataset.pdpRpInit = 'true';

    // Trigger ML recommendation fetch on first init if needed.
    maybeFetchRecommendations(root);

    var track = root.querySelector('[data-pdp-rp-track]');
    var prevBtn = root.querySelector('[data-pdp-rp-prev]');
    var nextBtn = root.querySelector('[data-pdp-rp-next]');
    var dotsContainer = root.querySelector('[data-pdp-rp-dots]');
    var controls = root.querySelector('[data-pdp-rp-controls]');

    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.pdp-rp__slide'));
    if (!slides.length) {
      if (controls) controls.style.display = 'none';
      return;
    }

    function getSlideOffset(slide) {
      return slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function getVisibleCount() {
      var trackWidth = track.clientWidth;
      var slide = slides[0];
      if (!slide) return 1;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var slideWidth = slide.getBoundingClientRect().width;
      if (slideWidth <= 0) return 1;
      var count = Math.round((trackWidth + gap) / (slideWidth + gap));
      return clamp(count, 1, slides.length);
    }

    function getPageCount() {
      var visible = getVisibleCount();
      return Math.max(1, slides.length - visible + 1);
    }

    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      var pageCount = getPageCount();
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-rp__dot';
        dot.setAttribute('data-pdp-rp-dot', String(i));
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dotsContainer.appendChild(dot);
      }
    }

    function getCurrentIndex() {
      var scrollLeft = track.scrollLeft;
      var minDelta = Infinity;
      var index = 0;
      for (var i = 0; i < slides.length; i++) {
        var delta = Math.abs(getSlideOffset(slides[i]) - scrollLeft);
        if (delta < minDelta) {
          minDelta = delta;
          index = i;
        }
      }
      return index;
    }

    function updateActiveStates() {
      var pageCount = getPageCount();
      var current = clamp(getCurrentIndex(), 0, pageCount - 1);
      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('.pdp-rp__dot');
        dots.forEach(function (dot, i) {
          if (i === current) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
      if (prevBtn && nextBtn) {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }
    }

    function scrollToIndex(index) {
      var pageCount = getPageCount();
      var clamped = clamp(index, 0, pageCount - 1);
      var target = slides[clamped];
      if (!target) return;
      track.scrollTo({ left: getSlideOffset(target), behavior: 'smooth' });
    }

    function maybeHideControls() {
      if (!controls) return;
      controls.style.display = getPageCount() <= 1 ? 'none' : '';
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(getCurrentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(getCurrentIndex() + 1); });

    if (dotsContainer) {
      dotsContainer.addEventListener('click', function (e) {
        var target = e.target;
        if (!(target instanceof Element)) return;
        var dot = target.closest('[data-pdp-rp-dot]');
        if (!dot) return;
        var i = parseInt(dot.getAttribute('data-pdp-rp-dot'), 10);
        if (!isNaN(i)) scrollToIndex(i);
      });
    }

    var scrollRaf = null;
    track.addEventListener('scroll', function () {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(updateActiveStates);
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildDots();
        maybeHideControls();
        updateActiveStates();
      }, 120);
    });

    buildDots();
    maybeHideControls();
    updateActiveStates();
  }

  function init() {
    var sections = document.querySelectorAll('[data-pdp-rp]');
    sections.forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector('[data-pdp-rp]')
      : null;
    if (section) setupSection(section);
  });
})();
